import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { Cookies } from 'react-cookie';
import { IOrderDetails, IOrderDetailsResponse } from '../../typescript/interfaces/order-interface';
import { attachApiErrorToastInterceptor } from '../../utils/api-error-toast';

const axiosInst = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_ORDER_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
attachApiErrorToastInterceptor(axiosInst);

axiosInst.interceptors.request.use((config) => {
  const cookies = new Cookies();
  const token = cookies.get('session_token');
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

type orderId = string | undefined;

export const paymentService = async (orderId: orderId) => {
  try {
    const response = await axiosInst.post(`/${orderId}/payment`);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getOrder = async (orderId: orderId): Promise<IOrderDetails> => {
  try {
    const response = await axiosInst.get<IOrderDetailsResponse>(`/${orderId}`);
    return response.data.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const orderDetails = (orderId: orderId, shouldRefetch: boolean) => {
  return useQuery({
    queryKey: ['order-details', shouldRefetch],
    queryFn: () => getOrder(orderId),
    refetchInterval: shouldRefetch && 2000,
  });
};

export type formData = {
  reason: string;
  comment?: string;
};

export const cancelOrder = async (orderId: orderId, reasonData: formData) => {
  const formData = {
    reason: +reasonData.reason,
    comment: reasonData.comment,
  };
  console.log(formData);
  try {
    const response = await axiosInst.post(`/${orderId}/cancel`, formData);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
